import type { FileMode as ImportMode } from "./file-import-state";
import { fileExtension } from "../shared/document-preview";
import { isDxfFile, isPdfFile } from "../shared/drawing-files";
import { imageFormatSupport } from "../shared/image-formats";

export function choicesFor(
  file: Pick<File, "name" | "type">,
): [ImportMode, string][] {
  const ext = fileExtension(file.name);
  if (isDxfFile(file))
    return [
      ["drawing", "AutoCAD DXF drawing"],
      ["attachment", "Downloadable file card"],
    ];
  if (isPdfFile(file))
    return [
      ["file", "Document with page navigation"],
      ["drawing", "Drawing sheet (one page)"],
      ["attachment", "Downloadable file card"],
    ];
  if (["docx", "rtf", "txt", "text", "md"].includes(ext))
    return [
      ["document", "Editable document"],
      ["file", "Read-only file preview"],
    ];
  if (["xlsx", "xls", "csv", "tsv"].includes(ext))
    return [
      ["table", "Editable table"],
      ["grid", "Editable visual grid"],
      ["file", "Read-only file preview"],
    ];
  const image = imageFormatSupport(file.name);
  if (image?.support === "still-preview")
    return [["file", `${image.format} still preview with image tools`]];
  if (image?.support === "attachment")
    return [["file", `${image.format} downloadable original`]];
  return [["file", "File preview"]];
}
